import { Link } from "react-router-dom";
import LoadJscript from "../components/LoadJscript";
import Newsletter from "../components/Newsletter";
const Contact = () => {
    return (
      <main>
        <div className="inner-banner inner-banner-bg">
            <div className="container">
                <div className="inner-title text-center">
                    <h3>Contact us</h3>
                    <ul>
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>Contact us</li>
                    </ul>
                </div>
            </div>
        </div>
    
        <div className="contact-info-area pt-100 pb-70">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-4  col-12 col-sm-8">
                        <div className="contact-info-card">
                            <i className="ri-map-pin-fill"></i>
                            <h3>Our location </h3>
                            <p>D-103A, Shivam Enclave Achheja, </p>
                            <p>Gautam Buddha Nagar 203207, Uttar Pradesh, India</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-6">
                        <div className="contact-info-card">
                            <i className="ri-mail-fill"></i>
                            <h3>Email us</h3>
                            <p><Link to="enquiry@lmsbee.com">enquiry@lmsbee.com</Link></p>
                            <p>&nbsp;</p>
                            </div>
                    </div>

                    <div className="col-lg-4 col-6">
                        <div className="contact-info-card">
                            <i className="ri-phone-fill"></i>
                            <h3>Phone</h3>
                            <p><a href="tel:+917307787435">+91 7307787435</a></p>
                            <p>&nbsp;</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  
        <div className="contact-widget-area pb-70">
            <div className="container">
                <div className="section-title text-center mb-45">
                    <span>SEND MESSAGE</span>
                    <h2>Ready to get started?</h2>
                </div>
                <div className="contact-form">
                    <form id="contactForm">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <input type="text" name="name" id="name" className="form-control" required data-error="Please Enter Your Name" placeholder="Name"/>
                                    <div className="help-block with-errors"></div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="form-group">
                                    <input type="email" name="email" id="email" className="form-control" required data-error="Please Enter Your Email" placeholder="Email"/>
                                    <div className="help-block with-errors"></div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="form-group">
                                    <input type="text" name="phone_number" id="phone_number" required data-error="Please Enter Your number" className="form-control" placeholder="Phone Number"/>
                                    <div className="help-block with-errors"></div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="form-group">
                                    <input type="text" name="msg_subject" id="msg_subject" className="form-control" required data-error="Please Enter Your Subject" placeholder="Your Subject"/>
                                    <div className="help-block with-errors"></div>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="form-group">
                                    <textarea name="message" className="form-control" id="message" cols="30" rows="7" required data-error="Write your message" placeholder="Your Message"></textarea>
                                    <div className="help-block with-errors"></div>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="agree-label">
                                    <input type="checkbox" id="chb1" />
                                    <label htmlFor="chb1">
                                        Accept <a href="terms-condition.html">Terms & Conditions</a> And <a href="privacy-policy.html">Privacy Policy.</a>
                                    </label>
                                </div>
                            </div>

                            <div className="col-lg-12 col-md-12">
                                <button type="submit" className="default-btn">
                                    Send Message
                                </button>
                                <div id="msgSubmit" className="h3 text-center hidden"></div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div className="contact-map-area pb-100">
            <div className="container">
                <div className="contact-map">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.843375899529!2d77.49074477358306!3d28.604475131625286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5c1f9c46381c81%3A0x74bcb5d9499e9af!2sBrightInfoVision%20Technologies%20Pvt.%20Ltd.-%20Website%20Design%20Company%20in%20Greater%20Noida!5e0!3m2!1sen!2sin!4v1734430089274!5m2!1sen!2sin" ></iframe>
                   </div>
            </div>
        </div>
       
         <Newsletter/>
         <LoadJscript/>
      </main>
    );
  }
  
  export default Contact;  